import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** A vendor/dealer as the API stores it. */
export interface Vendor {
  id?: number;
  name: string;
  businessRegistrationNumber: string;
  country: string;
  state: string;
  townCity: string;
  businessAddress: string;
  contactPerson: string;
  telephone: string;
  email: string;
  bankName: string;
  bankCode: string;
  accountNumber: string;
  accountName: string;
  assetCategories: string[];
}

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  private readonly baseUrl: string =
    environment.baseUrl + environment.accountUrl;

  constructor(private http: HttpClient) {}

  /** `req` is the same query string the other list pages build */
  public getVendors(req: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}vendors?${req}`);
  }

  public getVendor(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}vendors/${id}`);
  }

  public createVendor(data: Vendor): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}vendors`, data);
  }

  /* Only POST and GET were specified by the backend; these two follow the
     convention every other resource here uses and may need adjusting. */
  public updateVendor(id: number, data: Vendor): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}vendors/${id}`, data);
  }

  public deleteVendor(id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}vendors/${id}`);
  }

  /* Maker-checker. Same shape the loan product and deposit product lists use:
     a set of ids moved to one state, with a message carrying the reason when
     the action is a rejection. */
  public toggleVendors(data: {
    ids: number[];
    state: string;
    approved?: boolean;
    message: string;
  }): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}vendors/toggle`, data);
  }
}
